"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENT_LIABILITY_QUIZ_TYPE = exports.AvenAdvisorLiabilityQuizType = exports.AvenAdvisorLiabilityQuizLiabilityType = void 0;
var AvenAdvisorLiabilityQuizLiabilityType;
(function (AvenAdvisorLiabilityQuizLiabilityType) {
    AvenAdvisorLiabilityQuizLiabilityType["MORTGAGE"] = "mortgage";
    AvenAdvisorLiabilityQuizLiabilityType["HELOC"] = "heloc";
})(AvenAdvisorLiabilityQuizLiabilityType || (exports.AvenAdvisorLiabilityQuizLiabilityType = AvenAdvisorLiabilityQuizLiabilityType = {}));
var AvenAdvisorLiabilityQuizType;
(function (AvenAdvisorLiabilityQuizType) {
    AvenAdvisorLiabilityQuizType["TEXT_BOX_ONLY"] = "text_box_only";
    AvenAdvisorLiabilityQuizType["SLIDER_AND_TEXT_BOX"] = "slider_and_text_box";
})(AvenAdvisorLiabilityQuizType || (exports.AvenAdvisorLiabilityQuizType = AvenAdvisorLiabilityQuizType = {}));
exports.CURRENT_LIABILITY_QUIZ_TYPE = AvenAdvisorLiabilityQuizType.TEXT_BOX_ONLY;
